export const formStatus = {
  '1':{
    color:'',
    text:'未开始'
  },
  '2':{
    color:'blue',
    text:'暂存'
  },
  '3':{
    color:'red',
    text:'数据缺失'
  },
  '4':{
    color:'green',
    text:'已提交'
  },
  '5':{
    color:'orange',
    text:'已提交（失访）'
  }
}
export const formOpStatus = {
  // 1提交表单2失访3修改内容4提出质疑5回复质疑6关闭质疑
  '0':{
    color:'#7fcb53',
    text:'未知'
  },
  '1':{
    color:'#7fcb53',
    text:'提交表单'
  },
  '2':{
    color:'#F59A23',
    text:'失访'
  },
  '3':{
    color:'#02A7F0',
    text:'修改内容'
  },
  '4':{
    color:'red',
    text:'提出质疑'
  },
  '5':{
    color:'#4747FF',
    text:'回复质疑'
  },
  '6':{
    color:'red',
    text:'关闭质疑'
  },
  '7':{
    color:'red',
    text:'删除记录'
  },
  '8':{
    color:'red',
    text:'重置暂存'
  }
}
// 操作类型：1提交表单2失访3修改内容4提出质疑5回复质疑6关闭质疑
export const formOpType={
  "1":{
    color:'green',
    text:'提交表单'
  },
  "2":{
    color:'orange',
    text:'失访'
  },
  "3":{
    color:'cyan',
    text:'修改内容'
  },
  "4":{
    color:'red',
    text:'提出质疑'
  },
  "5":{
    color:'green',
    text:'回复质疑'
  },
  "6":{
    color:'pink',
    text:'关闭质疑'
  }
}